var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jdy-loading-box"},[_c('div',{staticClass:"jdy-loading"},[_c('span',{staticClass:"jdy-loading-inner"},[_c('i',{staticClass:"el-icon-loading text-blue"}),_vm._v(" "),_c('span',{staticClass:"text-info-shallow-more"},[_vm._t("default",[_vm._v("正在加载，请稍后...")])],2)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23d50330","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/loading.vue
// module id = null
// module chunks = 